import React from "react";
import Icon from "./icons";
import ParamsTable from "./ParamsTable";
import { BODY_MODES, RAW_FORMATS } from "./resourceTypes";

/**
 * The Body tab — mode on the left, that mode's editor on the right.
 *
 * Form Data and x-www-form-urlencoded keep separate row sets, so switching
 * between them does not move one's pairs into the other. Raw keeps its own text
 * and format.
 *
 * None of bodyMode / rawBody / rawFormat exists in the saved model yet; they go
 * out inside connectionData.requestValues, and the table modes also still fill
 * `bodyParams` so nothing that reads only that breaks. See payload.js.
 */
// rawError: the Raw text does not match its format (validateRawBody).
// missingError: a body type other than None with nothing in it (validateBodyPresence).
export default function BodyPanel({ body, onChange, errors, rawError, missingError }) {
  const set = (patch) => onChange({ ...body, ...patch });

  return (
    <div className="rsce-body">
      <div className="rsce-body-modes">
        {BODY_MODES.map((mode) => (
          <label className="rsce-radio" key={mode.value}>
            <input
              type="radio"
              name="rsce-body-mode"
              checked={body.mode === mode.value}
              onChange={() => set({ mode: mode.value })}
            />
            <span className="rsce-radio-label">{mode.label}</span>
          </label>
        ))}
      </div>

      <div className="rsce-body-editor">
        {body.mode === "none" && <p className="rsce-body-empty">This request is sent without a body.</p>}

        {body.mode === "formData" && (
          <ParamsTable rows={body.formData} errors={errors} onChange={(formData) => set({ formData })} />
        )}

        {body.mode === "urlencoded" && (
          <ParamsTable rows={body.urlencoded} errors={errors} onChange={(urlencoded) => set({ urlencoded })} />
        )}

        {(body.mode === "formData" || body.mode === "urlencoded") && missingError && (
          <div className="rsce-error-text">{missingError}</div>
        )}

        {body.mode === "raw" && (
          <>
            <div className="rsce-raw-bar">
              <div className="rsce-kvt-select-wrap rsce-raw-format">
                <select
                  className="rsce-kvt-select"
                  value={body.rawFormat}
                  onChange={(e) => set({ rawFormat: e.target.value })}
                >
                  {RAW_FORMATS.map((f) => (
                    <option key={f.value} value={f.value}>
                      {f.label}
                    </option>
                  ))}
                </select>
                <span className="rsce-kvt-select-caret">{Icon.caret}</span>
              </div>
            </div>
            <textarea
              className={`rsce-raw-editor ${rawError || missingError ? "has-error" : ""}`}
              spellCheck={false}
              rows={8}
              placeholder={'{\n  "key": "value"\n}'}
              value={body.rawBody}
              onChange={(e) => set({ rawBody: e.target.value })}
            />
            {(missingError || rawError) && <div className="rsce-error-text">{missingError || rawError}</div>}
          </>
        )}
      </div>
    </div>
  );
}
